module.exports = __webpack_public_path__ + "static/media/click-feedback.327237fc.wav";